import { domainLabel } from '@/features/common/useThematicDomains';
import { eventTextLang } from '@/features/publicsite/events/eventLanguage';
import type { EventCardMetaPart } from '@/features/publicsite/types/events/EventCardMetaPart';
import type { EventItem } from '@/features/publicsite/types/events/EventItem';
import type { Language } from '@/i18n/types';

/**
 * The line under an event card's date: its themes, its organiser and its place, each only when it
 * has one. It is what tells apart several events with one title — a series of workshops held in
 * different raions on different subjects read as the same event repeated. The place keeps its own
 * `lang`: on the English page it can still be the Romanian text.
 */
export function eventCardMeta(
  event: Pick<
    EventItem,
    'themeLabels' | 'organizerName' | 'location' | 'contentLanguage' | 'untranslatedFields'
  >,
  language: Language,
): EventCardMetaPart[] {
  const parts: EventCardMetaPart[] = [];
  if (event.themeLabels.length > 0) {
    parts.push({
      key: 'themes',
      text: event.themeLabels.map((theme) => domainLabel(theme, language)).join(', '),
    });
  }
  if (event.organizerName) parts.push({ key: 'organizer', text: event.organizerName });
  if (event.location) {
    parts.push({
      key: 'location',
      text: event.location,
      lang: eventTextLang(event, 'location', language),
    });
  }
  return parts;
}
